export default __webpack_public_path__ + "static/blog-1-97960340648fbd69bba9254e80760d8a.jpg";